// Wildcard
export const GRANTED = "granted"

// Implementados
export const EXPORT_BC3 = "export_bc3"
export const EXPORT_EXCEL = "export_excel"
export const EXPORT_EXCEL_CLIENT_PRICE = "export_excel_client_price"
export const EXPORT_EXCEL_COMMENTS = "export_excel_comments"
export const EXPORT_EXCEL_COST_PRICE = "export_excel_cost_price"
export const EXPORT_EXCEL_DECOMPOSITION = "export_excel_decomposition"
export const EXPORT_EXCEL_DECOMPOSITION_FILTER =
  "export_excel_decomposition_filter"
export const EXPORT_LISTO_XLS = "export_listo_xls"
export const EXPORT_EXCEL_MEASUREMENTS = "export_excel_measurements"
export const EXPORT_LISTO_PDF = "export_listo_pdf"
export const EXPORT_PDF = "export_pdf"
export const EXPORT_PDF_COVER = "export_pdf_cover"
export const EXPORT_PDF_DATE = "export_pdf_date"
export const EXPORT_PDF_DECOMPOSITION = "export_pdf_decomposition"
export const EXPORT_PDF_MEASUREMENTS = "export_pdf_measurements"
export const EXPORT_PDF_GENERALS = "export_pdf_generals"
export const EXPORT_PDF_INFO = "export_pdf_info"
export const EXPORT_PDF_NEW_FORMAT = "export_pdf_new_format"
export const EXPORT_PDF_SIGNATURE = "export_pdf_signature"
export const EXPORT_PDF_SUMMARY = "export_pdf_summary"
export const IMPORT_BC3_LINK = "import_bc3_link"
export const PURCHASE_ORDERS = "purchase_orders"
export const INVOICING = "invoicing"
export const CERTIFICATIONS = "certs"
export const CUSTOMIZE_PDF = "custom_pdf"
export const DYNAMIC_ELEMENTS = "ppe"
export const DYNAMIC_NUMERATION = "dynamic_numeration"
export const IMPORT_TEMPLATE = "import_template"
export const IMPORT_TCQ = "import_tcq"
export const IMPORT_PLANHOPPER = "import_planhopper"
export const EXTRAS = "extras"
export const BANKS_PUBLIC = "banks_public"
export const BANKS_CUSTOM = "banks_custom"
export const TEAM = "team"
export const TEMPLATES = "templates"
export const EXPENSES = "expenses"
export const OVERVIEW = "overview"
export const VERIFACTU = "verifactu"

// no implementados
export const PROJECT = "project" // banks
export const BANKS = "banks" // banks
